import app, { Component } from 'apprun';
import { serializeObject, companies, locations } from './api';
import { isValid, addOptions, showSaveStatusMessage } from './utils';

export default class LocationNewComponent extends Component {
  state = {};
  view = (state) =>{
    if (!state || !state.brokerageOptions) {return;}
    return <div>
      <form id="locNewForm" autocomplete="off">
        <div class="list-group">
          <div class="list-group-item">
          Name: <input id="locationName" name="locationName" class="pull-right" data-validate />
            <div id="locationNameErrMsg" class="text-danger" />
          </div>
          <div class="list-group-item">
          Location Type: &nbsp;
            <select id="locationTypeCt" name="locationTypeCt" class="pull-right" required="required" data-validate>
              <option value=" ">[Select]</option>
              {addOptions('LocationTypeCt', null)}
            </select>
            <div id="locationTypeCtErrMsg" class="text-danger" />
          </div>
          <div class="list-group-item">Company: &nbsp;
            <select id="companyID" name="companyID" required="required" data-validate disabled={state.companyId}>
              <option value=" ">[Select]</option>
              {state.brokerageOptions.map(r => (
                <option value={r.id} selected={r.id === state.companyId ? 'selected' : null}>
                  {r.id + ' - ' + r.name}
                </option>
              ))}
            </select>
            <div id="companyIDErrMsg" class="text-danger" />
          </div>
          <div class="list-group-item">
          Open Date: <input $pikaday id="locOpenDate" name="openDate" class="pull-right" data-validate="Date" />
            <div id="locOpenDateErrMsg" class="text-danger" />
          </div>
        </div>
      </form>
      <div class="edit-buttons pull-right">
        <button class="btn btn-xs btn-primary " $onclick='save'>Save</button>
        <button class="btn btn-xs btn-default" $onclick='cancel'>cancel</button>
      </div>
    </div>;
  }

  update = {

    save: async () => {
      try {
        const formName = 'locNewForm';
        if (!isValid(formName)) {return;}
        const formData = serializeObject(document.getElementById(formName));
        const result = await locations.post(0, formData);
        showSaveStatusMessage('location');
        app.run('#location', result);
      } catch {
        showSaveStatusMessage();
      }
    },

    cancel: () => {
      app.run('#clear-panel', 'locationNew');
    }
  };

  mounted = async ({ companyId }, _, state) => {
    if (!state.brokerageOptions) {
      state.brokerageOptions = await companies.getAllCompanies();
    }
    return { ...state, companyId };
  }
}
